import { IconRefresh02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** size */
  size?: 'md' | 'xl' | undefined;
}

const RefreshIcon = ({ size = 'md' }: IProps) => (
  <S.RefreshIcon className="refresh-icon" size={size}>
    <IconRefresh02 />
  </S.RefreshIcon>
);

export default RefreshIcon;
